// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15XPj","newExpiryDate":"styles_newExpiryDate__2HKmM","footer":"styles_footer__32KDH"};